import { render, staticRenderFns } from "./UpdateBlog.vue?vue&type=template&id=76765bdd"
import script from "./UpdateBlog.vue?vue&type=script&lang=js"
export * from "./UpdateBlog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports